import { getRequiredQuestions } from '../../containers/checkout/utils';
import { CheckoutState } from '../../state';
import { getQuestionsForBuyer } from './buyer';

export const getRequiredQuestionsForBuyer = (state: CheckoutState) =>
    getRequiredQuestions(getQuestionsForBuyer(state));
